import React from 'react';
import { View } from 'react-native';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import Row from '../../layout/Row';
import Typography from '../../typography/Typography';
import { renderNamedSlot } from 'src/utils/component';
const UnorderedItem = ({ children, ...rowProps }) => {
    const [{ theme, styles }] = useTheme(stylesGenerator);
    return (React.createElement(Row, { spacing: theme.spacing.standard.xs, ...rowProps },
        React.createElement(View, { style: styles.bullet }),
        React.createElement(Typography, { flex: true }, children)));
};
const IconItem = ({ Icon, children, ...rowProps }) => {
    const [{ theme }] = useTheme();
    return (React.createElement(Row, { spacing: theme.spacing.standard.xs, ...rowProps },
        renderNamedSlot(Icon),
        React.createElement(Typography, { flex: true }, children)));
};
const ListItemLayout = {
    Icon: IconItem,
    Unordered: UnorderedItem,
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    bullet: {
        width: 4,
        height: 4,
        borderRadius: 2,
        backgroundColor: theme.palette.typography.primary,
        marginTop: 10,
        marginLeft: 4,
    },
}));
export default ListItemLayout;
